import { Resources } from 'constants/resources';

import { ResourceProps } from 'react-admin';

import { ExpenseReportList } from './ExpenseReportList/ExpenseReportList';

export const expenseReportResource: ResourceProps = {
  name: Resources.ExpenseReport,
  list: ExpenseReportList,
  create: <></>,
  edit: <></>,
  show: <></>,
};
